import { Box } from '@mui/material'
import ReactEcharts, { EChartsOption } from 'echarts-for-react'
import React, { useMemo } from 'react'
import { useHistory } from 'react-router'

export interface DataFoundChartBar {
  count: number
  name: string
  color: string
  link: string | { pathname: string; search?: string }
}

interface DataFoundChartProps {
  bars: DataFoundChartBar[]
}

const DataFoundChart: React.FC<DataFoundChartProps> = ({ bars }) => {
  const history = useHistory()

  const totalValue = bars.reduce((acc, bar) => acc + bar.count, 0)
  const options: EChartsOption = {
    animation: false,
    type: 'bar',
    stack: 'chart',
    itemStyle: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
    xAxis: {
      show: false,
      max: totalValue,
      splitLine: { show: false },
      triggerEvent: true,
    },
    yAxis: {
      inverse: true,
      type: 'category',
      splitLine: { show: false },
      axisLine: { show: false },
      axisTick: { show: false },
      triggerEvent: true,
      axisLabel: { show: false },
    },
    grid: {
      top: 0,
      bottom: 0,
      right: 0,
      containLabel: false,
      show: false,
      left: 0,
    },
    series: bars.map(bar => ({
      name: bar.name,
      type: 'bar',
      stack: 'total',
      data: [bar.count],
      itemStyle: {
        color: bar.color,
        barBorderRadius: 0,
        borderWidth: 0.5,
        borderColor: '#fff',
        borderType: 'solid',
      },
    })),
  }

  const events = useMemo(
    () => ({
      click: (params: { dataIndex?: number }) => {
        const index = params.dataIndex || 0
        const link = bars[index].link
        if (link) history.push(link)
      },
    }),
    [bars, history],
  )

  return (
    <Box width="100px">
      <ReactEcharts option={options} onEvents={events} style={{ height: 16 }} />
    </Box>
  )
}

export default DataFoundChart
